import { ORDUserApi } from '@/features/settings'
import { GoogleDriveLoginForm } from '@/features/settings/marking'
import Advertiser from '@/features/settings/marking/advertiser'
import Agency from '@/features/settings/marking/agency'
import { useUpdateAdditionalOrdData } from '@/shared/api'
import {
    CheckIcon,
    ContentContainer,
    DisableTooltip,
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
} from '@/shared/ui'
import { useActiveWorkspace } from '@/true-fsd/data/advertiser-account/hooks'

export const MarkingWidget = () => {
    const {
        activeAwd,
        ordData: {
            ordAdditionalData: ordData,
            googleDriveConnection: googleUserInfo,
        },
    } = useActiveWorkspace()

    const selectedTab = ordData?.currentLinkType === 'agency' ? 'ra' : 'rd'

    const { mutate: updateAdditionalOrdData } = useUpdateAdditionalOrdData()

    // const { user } = useStore()

    // const shouldShowPA = useGetFeatureFlagByKey('RA', user?.user_id)

    function handleSelectTab(tab: 'rd' | 'ra') {
        updateAdditionalOrdData({
            awd: activeAwd,
            input: {
                currentLinkType: tab === 'rd' ? 'publisher' : 'agency',
            },
        })
    }

    const disableSwitchModes = Boolean(
        ordData?.vkOrdApiKey && ordData.adOrdContragentId
    )

    return (
        <div className="flex h-full w-full max-w-[918px] flex-col gap-4 overflow-y-auto">
            <h3 className="font-extrabold">Маркировка и документооборот</h3>
            {/* Title */}
            <Tabs
                value={selectedTab}
                onValueChange={(value) => handleSelectTab(value as 'rd' | 'ra')}
            >
                <TabsList className="grid h-auto w-full grid-cols-2 gap-4 pb-4">
                    <DisableTooltip
                        enabled={disableSwitchModes}
                        message="Нельзя переключаться между режимами"
                    >
                        <TabsTrigger
                            value="rd"
                            asChild
                            className="data-[state=active]:border-blue-primary"
                            disabled={disableSwitchModes}
                        >
                            <ContentContainer className="flex cursor-pointer flex-col border-2 border-white">
                                <div className="flex items-center gap-2 pb-3">
                                    <CheckIcon
                                        className="h-4 w-4"
                                        checked={selectedTab === 'rd'}
                                        variant="blue"
                                    />
                                    <h1 className="text-lg font-extrabold">
                                        Связка РД-РР
                                    </h1>
                                </div>
                                <p className="whitespace-normal break-words text-sm leading-none tracking-tight">
                                    Сценарий при котором рекламодатель (РД)
                                    работает с рекламораспространителем (РР)
                                    напрямую
                                </p>
                            </ContentContainer>
                        </TabsTrigger>
                    </DisableTooltip>
                    <DisableTooltip
                        enabled={disableSwitchModes}
                        message="Нельзя переключаться между режимами"
                    >
                        <TabsTrigger
                            value="ra"
                            asChild
                            className="data-[state=active]:border-blue-primary"
                            disabled={disableSwitchModes}
                        >
                            <ContentContainer className="flex cursor-pointer flex-col border-2 border-white">
                                <div className="flex items-center gap-2 pb-3">
                                    <CheckIcon
                                        className="h-4 w-4"
                                        checked={selectedTab === 'ra'}
                                        variant="blue"
                                    />
                                    <h1 className="text-lg font-extrabold">
                                        Связка РД-РА-РР
                                    </h1>
                                </div>
                                <p className="whitespace-normal break-words text-sm leading-none tracking-tight">
                                    Сценарий при котором рекламодатель (РД)
                                    работает с рекламораспространителем (РР)
                                    через агентство (РА)
                                </p>
                            </ContentContainer>
                        </TabsTrigger>
                    </DisableTooltip>
                </TabsList>

                <TabsContent value="rd" className="flex flex-col gap-4">
                    <ORDUserApi ordData={ordData} />

                    <Advertiser {...activeAwd} ordData={ordData} />

                    <GoogleDriveLoginForm
                        {...activeAwd}
                        googleUserInfo={googleUserInfo}
                    />
                </TabsContent>

                <TabsContent value="ra" className="flex flex-col gap-4">
                    <ORDUserApi ordData={ordData} />

                    <Agency {...activeAwd} ordData={ordData} />

                    <Advertiser {...activeAwd} ordData={ordData} />

                    <GoogleDriveLoginForm
                        {...activeAwd}
                        googleUserInfo={googleUserInfo}
                    />
                </TabsContent>
            </Tabs>
        </div>
    )
}
